let trustedUrlFilter = ($sce) => {
    'ngInject';
    return (input) => {
        return $sce.trustAsUrl(input);;
    };
};

export default trustedUrlFilter;